export default "__VITE_ASSET__BJCHObAW__"